import React, { useState } from "react";
import Contacts from "@/pages/contacts";

const Ukvisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/ukimg.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
      <div className="mt-10 w-full px-5 md:w-3/4 md:ml-20 lg:ml-32 text-center md:text-left text-3xl font-bold text-[#011473] drop-shadow-md">
  Visa World’s Complete Guide to Immigration and Visas
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/visituk.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        <div className="space-y-2 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Expert Guidance:</a> Receive personalized support for a
              hassle-free UK visit visa application process.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Tailored Solutions:</a> Whether for tourism, business, or visiting
              loved ones, we offer customized services for your specific needs.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Seamless Process:</a> We guide you through every step of the
              application, ensuring a smooth experience.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Clear & Simple:</a> Understand all the requirements and
              documentation easily, maximizing your chances for approval.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Standard Visitor Visa:</a> Allows visits for tourism, business,
              events, or family for up to 6 months.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Valid Passport:</a> Ensure you have a valid travel document to
              apply for the visa.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Financial Proof:</a> Demonstrate that you have the means to
              support yourself during your stay.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Intent to Return: </a>Provide evidence that you plan to return to
              your home country after your visit.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-black font-bold">Purpose of Visit:</a> Provide details such as your travel plans,
              business meetings, or family visits.
            </span>
          </div>
        </div>
      </div>

      <div className="mt-10 w-full px-5  md:w-full md:px-20 lg:mt-10 xl:mt-10">
        <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
          Types of UK Visit Visa
        </p>
        <div className="container mx-auto mb-10 mt-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
            <div className="flex items-center justify-center">
              <img
                src="/bussines.jpg" // Replace with your image URL
                alt="Student Visas"
                className="h-auto w-full rounded-xl shadow-md"
              />
            </div>
            <div className="flex flex-col text-black justify-left pl-4 text-left md:text-left">
              <ul className="mb-4 list-disc space-y-10 pl-5">
                <li>
                  <strong>Tourist Visa:</strong> Ideal for travelers who wish to
                  explore the UK’s landmarks, cultural attractions and enjoy
                  leisure activities.
                </li>
                <li>
                  <strong>Business Visa:</strong> Designed for individuals
                  attending business events, conferences, or meetings in the UK.
                </li>
                <li>
                  <strong>Family Visit Visa:</strong> Allows you to visit family
                  members residing in the UK.
                </li>
                <li>
                  <strong>Short-Term Study Visa:</strong> For students enrolled
                  in short-term educational programs or research lasting up to
                  six months.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
        <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
          Tips for a Successful UK Visit Visa Application
        </p>
        <div className="container mx-auto text-black mb-10 mt-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
            <div className="flex flex-col justify-left pl-4 text-left md:text-left">
              <ul className="mb-4 list-disc space-y-10 pl-5">
                <li>
                  <strong>Accurate Information:</strong> Double-check that all
                  your application details are precise and truthful.
                </li>
                <li>
                  <strong>Document Organization:</strong> Ensure all necessary
                  documents are prepared and presented clearly.
                </li>
                <li>
                  <strong>Evidence of Ties to Home Country:</strong> Provide
                  proof that you intend to return after your visit.
                </li>
                <li>
                  <strong>Professional Assistance:</strong> Consult with an
                  immigration expert for a smooth visa application process.
                </li>
              </ul>
            </div>
            <div className="flex items-center justify-center">
              <img
                src="/ukapplications.jpg" // Replace with your image URL
                alt="Visa World Business"
                className="h-96 w-full rounded-xl shadow-md"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full flex-col text-black items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Expert Guidance</strong>: Get professional support for a smooth UK visit visa application process.
        <br />
        - <strong>Tailored Services</strong>: Whether it's for leisure, business, or visiting family and friends, we offer personalized solutions.
        <br />
        - <strong>Comprehensive Assistance</strong>: We provide step-by-step guidance, from eligibility checks to application submission.
        <br />
        - <strong>Clear & Simple</strong>: Understand all the requirements, documents and tips to increase your chances of approval.
        <br />
        Let Visa World simplify your UK visit visa journey and ensure a hassle-free experience!
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Welcome to Visa World – Your Reliable Guide for UK Visit Visa Applications
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>


      <Contacts />
    </>
  );
};

export default Ukvisitvisa;
